<template>
  <div class="survey">
    <div class="question-container" v-if="variable">
      <span class="label">{{ i18n('surveyQuestion', variableName) | formatTitle }}</span>
      <span class="var-description" v-if="description">{{ description }}</span>
      <MobileSlider v-if="variable.type === 'numeric'" :start="variableAttr" :values="getPoints(variableName, 100)" :key="variableAttr" @update="sliderValue = $event"/>
      <div v-if="variable.type === 'numeric'" class="buttons">
        <button @click="update(sliderValue)">{{ i18n('general', 'next') | firstCharUpper }}</button>
      </div>
      <div v-else-if="variable.type === 'logical'" class="buttons">
        <button @click="update(true)" class="green">{{ i18n('general', 'yes') | firstCharUpper }}</button>
        <button @click="update(false)" class="red">{{ i18n('general', 'no') | firstCharUpper }}</button>
      </div>
      <div v-else-if="variable.type === 'categorical'" class="buttons">
        <button v-for="l in variable.levels" @click="update(l)" :key="l">{{ i18n('variableValues', l) | firstCharUpper }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import format from '@/utils/format.js'
import MobileSlider from '@/components/MobileSlider.vue'

/* eslint-disable arena/no-hardcode-param-types */

export default {
  name: 'Survey',
  data () {
    return {
      attributes: null,
      variables: null,
      question: 0,
      sliderValue: null
    }
  },
  filters: {
    formatTitle: format.formatTitle,
    firstCharUpper: format.firstCharUpper
  },
  watch: {
    label: {
      handler: 'loadAttributes',
      immediate: true
    },
    pageNumber (n) {
      // -1 is set only when refreshing
      if (n === -1) this.loadAttributes()
    },
    attributes () {
      if (!this.attributes) {
        this.variables = null
        return
      }
      let attributes = this.attributes
      let promises = Object.keys(this.attributes).map(v => this.$store.dispatch('getAttributes', { paramType: 'variable', paramValue: v }))
      Promise.all(promises).then(results => {
        if (attributes !== this.attributes) return
        this.variables = results.map((attr, index) => ([Object.keys(attributes)[index], attr])).filter(r => r[1]).reduce((acu, [v, attr]) => ({ ...acu, [v]: attr }), {})
      }).catch(this.clear)
    },
    variable () {
      if (this.variable.type === 'numeric') this.sliderValue = this.variableAttr
    }
  },
  computed: {
    label () {
      return this.getGlobalParam('observation')
    },
    variablesNames () {
      if (!this.attributes || !this.variables) return []
      let getOrder = (v) => this.availableParams.variable.indexOf(v)
      return Object.keys(this.attributes).filter(x => this.variables[x]).sort((a, b) => getOrder(a) - getOrder(b))
    },
    variableName () {
      return this.variablesNames[this.question] || ''
    },
    variable () {
      return (this.variables || {})[this.variableName]
    },
    variableAttr () {
      return (this.attributes || {})[this.variableName]
    },
    description () {
      let desc = this.i18n('variableDescription', this.variableName)
      return desc === this.variableName ? null : desc
    },
    ...mapGetters(['getGlobalParam', 'pageNumber', 'i18n', 'availableParams'])
  },
  methods: {
    loadAttributes () {
      let attributes = this.attributes
      if (!this.label) return
      if (format.isCustomParam(this.label)) {
        this.$nextTick(() => {
          this.attributes = JSON.parse(this.label)
        })
      } else {
        this.$store.dispatch('getAttributes', { paramType: 'observation', paramValue: this.label }).then(x => {
          if (!x || this.attributes !== attributes) return
          this.attributes = x
        }).catch(this.clear)
      }
    },
    clear () {
      this.attributes = null
      this.variables = null
    },
    getPoints (variable, n) {
      let v = this.variables[variable]
      if (v.levels) return [...v.levels].sort((a, b) => a - b)
      return [...Array(n).keys()].map(x => x / (n - 1)).map(x => v.min + (x * (v.max - v.min)))
    },
    update (value) {
      let variable = this.variableName
      if (this.attributes[variable] !== value) {
        this.$store.commit('setGlobalParam', { name: 'observation', value: JSON.stringify({ ...this.attributes, [variable]: value }) })
      }
      this.question += 1
      if (this.question >= this.variablesNames.length) {
        this.$emit('done')
      }
    }
  },
  components: { MobileSlider }
}
/* eslint-enable arena/no-hardcode-param-types */

</script>
<style>
div.survey {
  position: absolute;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 100;
}
div.survey > div.question-container {
  padding: 0 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: calc(100% - 60px);
  text-align: center;
}
div.survey > div.question-container > span.label {
  font-size: 60px;
  font-family: 'Fira Sans';
}
div.survey > div.question-container > div.buttons {
  margin-top: 30px;
}
div.survey > div.question-container > div.mobile-slider {
  margin-top: 30px;
}
div.survey > div.question-container > div.buttons > button {
  color: white;
  box-shadow: 0 0 5px 0 #371ea340;
  border-radius: 6px;
  margin: 0 15px;
  background: #371ea3;
  padding: 5px 10px;
  font-size: 40px;
  border: none;
}
div.survey > div.question-container > div.buttons > button.green {
  background: #46bac2;
  box-shadow: 0 0 5px 0 #46bac240;
}
div.survey > div.question-container > div.buttons > button.red {
  background: #f05a71;
  box-shadow: 0 0 5px 0 #f05a7140;
}
div.survey > div.question-container > div.plot-dropdown {
  max-width: none !important;
  cursor: pointer;
}
div.survey > div.question-container span.var-description {
  display: block;
  color: #555;
  font-size: 25px;
}
</style>
